import { render, staticRenderFns } from "./expansionSchema.vue?vue&type=template&id=b70a1796&scoped=true"
import script from "./expansionSchema.vue?vue&type=script&lang=js"
export * from "./expansionSchema.vue?vue&type=script&lang=js"
import style0 from "./expansionSchema.vue?vue&type=style&index=0&id=b70a1796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70a1796",
  null
  
)

export default component.exports